import type { LucideIcon } from 'lucide-react'

import { BarChart3, Building2, Calendar, CalendarDays, CalendarRange, CheckSquare, ClipboardList, Settings, UserCog, Users } from 'lucide-react'

interface BreadcrumbItem {
  title: string
  link: string
}

type NavRole = 'admin' | 'orgAdmin' | 'supervisor'

interface NavLink {
  title: string
  url: string
  icon?: LucideIcon
  roles?: NavRole[]
}

interface NavSection {
  title: string
  url: string
  icon?: LucideIcon
  roles?: NavRole[]
  items?: NavLink[]
}

export const routeMapping: Record<string, BreadcrumbItem[]> = {
  '/profile': [{ title: 'My Profile', link: '/profile' }],
  '/user-management/department-members': [{ title: 'Department Members', link: '/user-management/department-members' }],
  '/user-management/directorates': [{ title: 'Directorates', link: '/user-management/directorates' }],
  '/user-management/departments': [{ title: 'Departments', link: '/user-management/departments' }],
  '/user-management/supervisors': [{ title: 'Supervisors', link: '/user-management/supervisors' }],
  '/leave/applications': [{ title: 'Leave Applications', link: '/leave/applications' }],
  '/leave/approvals': [{ title: 'Supervisor Approvals', link: '/leave/approvals' }],
  '/leave/calendar': [{ title: 'Leave Calendar', link: '/leave/calendar' }],
  '/leave/request': [{ title: 'Request Leave', link: '/leave/request' }],
  '/leave-mgt/delegations': [{ title: 'Delegations', link: '/leave-mgt/delegations' }],
  '/leave/tracking': [{ title: 'Track Leave', link: '/leave/tracking' }],
  '/leave-mgt/reports': [{ title: 'Leave reports', link: '/leave-mgt/reports' }],
  '/leave/config/leave-types': [{ title: 'Leave Types', link: '/leave/config/leave-types' }],
  '/leave/config/balances': [{ title: 'Leave Balances', link: '/leave/config/balances' }],
  '/leave/config/holidays': [{ title: 'Holidays', link: '/leave/config/holidays' }],
  '/leave/config/entitlements': [{ title: 'Entitlements', link: '/leave/config/entitlements' }],
  '/leave/config/departments': [{ title: 'Departments', link: '/leave/config/departments' }],
  '/leave/supervisors': [{ title: 'Supervisors', link: '/leave/supervisors' }],
  '/leave-mgt/leave-requests': [{ title: 'All Leave Requests', link: '/leave-mgt/leave-requests' }],
  '/access-denied': [{ title: 'Access Denied', link: '/access-denied' }],
}

export const navItems: {
  // user: {
  //   name: string
  //   email: string
  //   avatar: string
  // }
  navMain: NavLink[]
  navCollapsible: NavSection[]
  navSecondary: NavLink[]
  navSettings: NavSection[]
} = {
  // user: {
  //   name: 'Admin',
  //   email: 'info@uibfs.or.ug',
  //   avatar: '/avatars/shadcn.jpg',
  // },
  navMain: [
    {
      title: 'My Profile',
      url: '/profile',
      icon: UserCog,
    },
    {
      title: 'Leave Calendar',
      url: '/leave/calendar',
      icon: CalendarRange,
    },
    {
      title: 'My Leave Applications',
      url: '/leave/applications',
      icon: Calendar,
    },
    {
      title: 'Supervisor Approvals',
      url: '/leave/approvals',
      icon: CheckSquare,
      roles: ['supervisor'],
    },
  ],
  navCollapsible: [
    {
      title: 'Leave Management',
      url: '/leave-mgt',
      icon: Calendar,
      roles: ['admin', 'orgAdmin'],
      items: [
        {
          title: 'All Leave Requests',
          url: '/leave-mgt/leave-requests',
          icon: ClipboardList,
          roles: ['admin', 'orgAdmin'],
        },
        {
          title: 'Delegations',
          url: '/leave-mgt/delegations',
          icon: Users,
          roles: ['admin', 'orgAdmin'],
        },
        {
          title: 'Leave Reports',
          url: '/leave-mgt/reports',
          icon: BarChart3,
          roles: ['admin', 'orgAdmin'],
        },
        {
          title: 'Leave Balances',
          url: '/leave/config/balances',
          icon: ClipboardList,
          roles: ['admin', 'orgAdmin'],
        },
      ],
    },
    {
      title: 'User Management',
      url: '/user-mgt',
      icon: UserCog,
      roles: ['admin', 'orgAdmin'],
      items: [
        {
          title: 'Staff Members',
          url: '/user-mgt/staff-members',
          icon: Users,
          roles: ['admin', 'orgAdmin'],
        },
        {
          title: 'Supervisors',
          url: '/user-mgt/supervisors',
          icon: UserCog,
          roles: ['admin', 'orgAdmin'],
        },
        {
          title: 'Directorates',
          url: '/user-mgt/directorates',
          icon: Building2,
          roles: ['admin', 'orgAdmin'],
        },
        {
          title: 'Departments',
          url: '/user-mgt/departments',
          icon: Building2,
          roles: ['admin', 'orgAdmin'],
        },
      ],
    },
    {
      title: 'Leave Config',
      url: '/leave/config',
      icon: Settings,
      roles: ['admin', 'orgAdmin'],
      items: [
        {
          title: 'Leave Types',
          url: '/leave/config/leave-types',
          icon: ClipboardList,
          roles: ['admin', 'orgAdmin'],
        },
        {
          title: 'Holidays',
          url: '/leave/config/holidays',
          icon: CalendarDays,
          roles: ['admin', 'orgAdmin'],
        },
      ],
    },
  ],
  navSecondary: [],
  navSettings: [],
}
